import { useTranslation } from 'react-i18next';

import { TextField, TextFieldProps } from '@anytag/shared-molecules';

import { MarketplaceFormKeys } from '../types';

export const AgencyMarginRateField = (props: Omit<TextFieldProps, 'name'>) => {
  const { t } = useTranslation();

  return (
    <TextField
      rightSection="%"
      placeholder="10"
      title={t('TextForm.Ad Agency Margin Rate')}
      help={t('Tooltip.Agency Rate Help Text')}
      name={MarketplaceFormKeys.agencyMarginRate}
      {...props}
    />
  );
};
